import DestacatBasic from 'components/corporatiu/Destacat/DestacatBasic';

const ItemResultatDefault = (props) => {
    const { item, routePath, mostrarData, mostrarEntradeta, mostrarImatge } = props;
    return (
        <article>
            <DestacatBasic
                key={`destacat-cerca-${item.index}`}
                item={item}
                routePath={routePath}
                mostrarData={mostrarData}
                mostrarEntradeta={mostrarEntradeta}
                mostrarImatge={mostrarImatge}
                disposicio='horitzontal'
                retallarEntradeta={true}
            />
        </article>
    );
};

export default ItemResultatDefault;
